import { ChangeEvent, Dispatch } from 'react'
import { AppAction, AppState } from '../appState'
import CustomInput from './CustomInput'
import { EventUnionType } from './MortgageCalculator'
import { TypographyH2 } from './typographyComponents'

interface Props {
  appState: AppState
  appDispatch: Dispatch<AppAction>
}

function CostsCalculator({ appState, appDispatch }: Readonly<Props>) {
  function onChangeHandler(event: EventUnionType) {
    const field = (event as ChangeEvent<HTMLInputElement>).currentTarget.id
    if (field !== 'monthlyFee' && field !== 'yearlyOperatingCost')
      return appDispatch({ type: 'error' })
    const trimmedValue = event.target.value.replace(/\s+/g, '')
    const numericValue =
      field === 'yearlyOperatingCost' ? +trimmedValue * 12 : +trimmedValue
    appDispatch({ type: 'fieldChange', field, value: numericValue })
  }

  const { houseObject, monthlyFee, yearlyOperatingCost } = appState
  const monthlyOperatingCost = Math.round(yearlyOperatingCost / 12)

  // If the query string does not include information we use a default value
  const monthlyOperatingCostInformationMessage =
    houseObject !== null &&
      (houseObject?.drift === undefined || houseObject?.drift === 0)
      ? 'Vi kunde inte hämta driftskostnaden för den här bostaden och har därför lagt till en schablonkostnad.'
      : undefined

  return (
    <section className="border-2 border-neutral-80 p-[14px]">
      <TypographyH2>Boende</TypographyH2>
      <div className="flex flex-wrap">
        <CustomInput
          id="monthlyFee"
          label="Avgift"
          value={monthlyFee}
          inputChangeHandler={onChangeHandler}
          suffix="kr/mån"
          maxLength={6}
        />
        <CustomInput
          id="yearlyOperatingCost"
          label="Driftkostnad"
          value={monthlyOperatingCost}
          inputChangeHandler={onChangeHandler}
          suffix="kr/mån"
          maxLength={6}
          additionalInformationMessage={monthlyOperatingCostInformationMessage}
        />
      </div>
    </section>
  )
}

export default CostsCalculator
